import { Component, OnChanges, Input, SimpleChange, Inject } from "@angular/core";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from "angular-l10n";

@Component({
  selector: "password-strength-bar",
  templateUrl: "passwordStrengthBar.template.html"
})
export class PasswordStrengthBarComponent implements OnChanges {
  private static measureStrength(p) {
    const _lowerLetters = /[a-z]+/.test(p);
    const _upperLetters = /[A-Z]+/.test(p);
    const _numbers = /[0-9]+/.test(p);
    const _symbols = /[$-/:-?{-~!"^_`\[\]]/g.test(p);
    const length = p.length;
    let strength = 1;
    if (p.length > 8) {
      let _passedMatches = 0;
      const _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
      for (const _flag of _flags) {
        _passedMatches += _flag === true ? 1 : 0;
      }
      strength += _passedMatches;
    }
    return strength;
  }

  @Input() passwordToCheck: string;
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;
  private colors = ["#F00", "#F90", "#FF0", "#9F0", "#0F0"];

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private translation: L10nTranslationService,) {
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes["passwordToCheck"].currentValue;
    this.setBarColors(5, "#DDD");
    if (password) {
      const passwordStrength = PasswordStrengthBarComponent.measureStrength(password);
      this.setBarColors(passwordStrength, this.colors[passwordStrength - 1]);
    }
  }

  private setBarColors(count, col) {
    for (let _n = 0; _n < count; _n++) {
      this["bar" + _n] = col;
    }
  }

}
